import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {InsuranceCompany} from '../interface/insurance-company';
import {first, take} from 'rxjs/operators';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {Uuid} from '../interface/response/uuid';

export const IC_LINK4 = 'link4';
export const IC_ALLIANZ = 'allianz';
export const IC_PZU = 'pzu';
export const IC_PZU_LIFE = 'pzu_life';
export const IC_COMPENSA = 'compensa';
export const IC_COMPENSA_LIFE = 'compensa_life';
export const IC_WIENER = 'wiener';
export const IC_EUROPA = 'europa';
export const IC_EUROP_ASSISTANCE = 'europ_assistance';
export const IC_INTER_POLSKA = 'inter_polska';
export const IC_INTER_POLSKA_LIFE = 'inter_polska_life';
export const IC_ERGO_HESTIA = 'ergo_hestia';
export const IC_ERGO_HESTIA_LIFE = 'ergo_hestia_life';
export const IC_GENERALI = 'generali';
export const IC_GENERALI_LIFE = 'generali_life';
export const IC_SIGNAL_IDUNA = 'signal_iduna';
export const IC_SIGNAL_IDUNA_LIFE = 'signal_iduna_life';
export const IC_TRASTI = 'trasti';
export const  IC_BALCIA = 'balcia';
export const IC_WARTA = 'warta';
export const IC_UNIQA = 'uniqa';
export const IC_UNIQA_INTERRISK = 'interrisk';
export const IC_COLONNADE = 'colonnade';
export const IC_RESO = 'reso';
export const IC_TUZ_UBEZPIECZENIA = 'tuz_ubezpieczenia';
export const IC_TUW_TUW = 'tuw_tuw';
export const IC_POCZTOWE_TUW = 'pocztowe_tuw';
export const IC_LLOYDS_LIFE = 'lloyds_life';
export const IC_METLIFE = 'met_life';
export const IC_PRU = 'pru';
export const IC_AWP = 'awp';
export const IC_DEFEND = 'defend';
export const IC_EUROINS = 'euroins';
export const IC_OPEN_LIFE = 'open_life';
export const IC_UNUM_LIFE = 'unum_life';
export const IC_PREVOIR = 'prevoir';
export const IC_WARTA_LIFE = 'warta_life';

export const IC_WITH_SALES_PROFILES = [
  IC_ERGO_HESTIA,
  IC_ERGO_HESTIA_LIFE,
  IC_GENERALI,
  IC_GENERALI_LIFE
];

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyService {
  private readonly insuranceCompaniesPage: ReplaySubject<CountedAndPaginated<InsuranceCompany>> =
    new ReplaySubject<CountedAndPaginated<InsuranceCompany>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/insuranceCompany?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
        this.insuranceCompaniesPage.next(result);
      });
  }
  public sendForm(formData: object, id?: string): Observable<any> {
    if (!id) {
      return this.httpClient.post('/rest/crm/insuranceCompany', formData)
        .pipe(first());
    } else {
      return this.httpClient.put(`/rest/crm/insuranceCompany/${id}`, formData)
        .pipe(first());
    }
  }

  public getInsuranceCompaniesPageSubject(): ReplaySubject<CountedAndPaginated<InsuranceCompany>> {
    return this.insuranceCompaniesPage;
  }

  public downloadReport(filters: object): void {
    this.document.location.href = `/rest/crm/insuranceCompany/method/report?` + this.filterService.parseFilters(filters);
  }

  public get(id: string): Observable<InsuranceCompany> {
    return this.httpClient.get(`/rest/crm/insuranceCompany/${id}`)
      .pipe(first()) as Observable<InsuranceCompany>;
  }

  public updateImage(id: number, fileBase64: any): Observable<any> {
    return this.httpClient.put(`/rest/crm/insuranceCompany/${id}/image`, {
      content: fileBase64
    }).pipe(first());
  }

  public updateContent(formData: object, id: number): Observable<any> {
    return this.httpClient.put(`/rest/crm/insuranceCompany/${id}/content`, formData)
      .pipe(
        take(1)
      ) as Observable<Uuid>;
  }

  public downloadFile(id: number): void {
    this.document.location.href = `/rest/crm/insuranceCompany/${id}/downloadFile`;
  }

  public deleteFile(id: number): Observable<any> {
    return this.httpClient.delete(`/rest/crm/insuranceCompany/${id}/deleteFile`)
      .pipe(first()) as Observable<any>;
  }
  updateBlockRegistrations(insuranceObjectId: number, blockRegistrations: boolean): Observable<Uuid> {
    return this.httpClient.put(`/rest/crm/insuranceCompany/${insuranceObjectId}/blockRegistrations`, {
      blockRegistrations
    }).pipe(first()) as Observable<Uuid>;
  }

  public getAllInsuranceCompanies(): Observable<CountedAndPaginated<InsuranceCompany>> {
    return this.httpClient.get(`/rest/crm/insuranceCompany?pageSize=1000`)
      .pipe(first()) as Observable<CountedAndPaginated<InsuranceCompany>>;
  }
}
